var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":_vm.absolute,"opacity":_vm.opacity,"value":_vm.loading,"z-index":_vm.zIndex}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.spinnerColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }